// extracted by mini-css-extract-plugin
module.exports = {"skuDetailsDataPanels":"-sku-details-skuDetailsDataPanels-3IIZaG-","skuDetailsDataRow":"-sku-details-skuDetailsDataRow-2sdHKh-"};